module.exports = __webpack_public_path__ + "img/lab2.49d332c7.png";